import React, { Component } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getMoreContent } from '../../../../app/selectors/selector';
import { Support } from '../../../web/pages/Support/SupportPage';

export class SupportContainer extends Component<any, any> {
  render() {
    const menuItemDetails = this.props && this.props.menuData && this.props.menuData.data && this.props.menuData.data.getUserHelpContent
    return <Support menuItemDetails = {menuItemDetails} {...this.props} />;
  }
}
const mapStateToProps = createStructuredSelector({
  menuData: getMoreContent()
});


export default connect(mapStateToProps)(SupportContainer);
